<template>
  <v-layout>
    <v-flex class="scroll-y">

      <data-table :items="unitaMobili"
                  :headers="[{text: $t('unita_mobili.label.targa'), value: 'targa', sortable: true, width: 20},
                           {text: $t('label.descrizione'), value: 'descrizione', width: 80}]"
                  initial-sort="targa"
                  :loading="loading"
                  show-header-button :toggled.sync="showDeleted"
                  @click:item="(unitaMobile) => (showDeleted ? showDeletedDialog(unitaMobile) : showEditDialog(unitaMobile))">

        <template slot="items" slot-scope="{item}">
          <td>{{ item.targa }}</td>
          <td>{{ item.descrizione }}</td>
          <td>
            <v-btn v-if="!$store.getters.isAbbonamentoExpired" v-show="!showDeleted" icon small flat class="right"
                   @click.stop="showDeleteConfirmDialog(item.targa)">
              <v-icon>clear</v-icon>
            </v-btn>
          </td>
        </template>
      </data-table>

      <v-btn v-if="!$store.getters.isAbbonamentoExpired" v-show="!showDeleted" @click="showCreateDialog" color="accent"
             fixed right bottom round large class="mr-2">
        <v-icon class="mr-2">add</v-icon>
        {{ $t('azioni.aggiungi') }}
      </v-btn>

      <unita-mobile-dialog ref="unitaMobileDialog" @success="successUnitaMobileDialog"/>
      <unita-mobile-deleted-dialog ref="unitaMobileDeletedDialog" @success="fetchData(true)"/>

    </v-flex>
  </v-layout>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import UnitaMobileDialog from '@/components/UnitaMobileDialog'
import UnitaMobileDeletedDialog from '@/components/UnitaMobileDeletedDialog'

export default {
    name: 'UnitaMobili',
    components: {
        DataTable,
        UnitaMobileDialog,
        UnitaMobileDeletedDialog
    },
    data: () => ({
        showDeleted: false,
        loading: false,
        unitaMobili: []
    }),
    watch: {
        showDeleted: {
            handler: 'fetchData',
            immediate: true
        }
    },
    methods: {
        showCreateDialog () {
            this.$refs.unitaMobileDialog.showCreate()
        },
        showEditDialog (unitaMobile) {
            this.$refs.unitaMobileDialog.showEdit(unitaMobile, unitaMobile.prodotti)
        },
        successUnitaMobileDialog () {
            this.fetchData(true)
        },
        showDeletedDialog (unitaMobile) {
            this.$refs.unitaMobileDeletedDialog.show(unitaMobile)
        },
        showDeleteConfirmDialog (targa) {
            this.$confirmDialog.show(targa, this.$t('messaggi.conferma_eliminazione'), this.deleteUnitaMobile)
        },
        deleteUnitaMobile (targa) {
            this.$api.unitaMobili.delete(targa)
                .then(response => {
                    this.$snackbar.show(this.$t('unita_mobili.messaggi.eliminato'), 'success')
                    this.fetchData(true)
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('unita_mobili.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        },
        action () {
            if (this.showDeleted) {
                return this.$api.unitaMobili.getDeleted()
            } else {
                return this.$api.unitaMobili.getAll()
            }
        },
        fetchData (updateStore = false) {
            this.loading = true
            this.action()
                .then(response => {
                    this.loading = false
                    this.unitaMobili = response.data

                    if (updateStore) {
                        // Viene forzato l'aggiornamento per i select unità mobile, solo se viene aggiornata la lista degli attivi
                        this.$store.commit('SET_UNITA_MOBILI', [])
                    }
                })
                .catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        }
    }
}
</script>
